import { Outlet } from 'react-router-dom';
import InputMask from 'react-input-mask';
import Box from 'components/ui/box';
import { useEffect, useRef, useState } from 'react';
import { getResultadosCultura, getResultadosCulturaSecond } from 'services/dashboard.service';
import ArticlePlaceholder from 'components/ui/article-placeholder';
import Avatar from 'funifier-nice-avatar';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';

import { Selo } from 'components/icons';
import { GetBehaviorDescription, GetBehaviorTextDestaque } from 'utils/strings';
import { TbSearch } from 'react-icons/tb';
import { BsPlusLg } from 'react-icons/bs';
import { DestaquesCulturaDetail } from './detail';
import ReactPaginate from 'react-paginate';
import CustomSelect from 'components/custom-select';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import Tippy from '@tippyjs/react';
import { getNamedDates } from 'services/utils';

const release = true;

// const options: any = [{ value: 0, label: 'Ciclo 1/2023' }];

interface DestaqueCulturaProps {
  showHead: (item: boolean) => void;
  options: any;
}

function typeText() {
  return (
    <p>
      Para ser um Destaque da Cultura em uma das dimensões Colaboração, Inovação, Foco no Cliente, Protagonismo ou Liderança
      Integradora (funções gerenciais) e ser premiado com 2.000 (dois mil) pontos e Selo no Humanograma, você precisa:
      <br /> <br />
      Alcançar no mínimo 5 (cinco) reconhecimentos na respectiva dimensão do comportamento;
      <br /> <br />
      Não estar no nível Iniciante; e Não estar no nível Iniciante;
      <br /> <br />
      Estar com a pontuação dentre as 5% melhores do seu grupo em uma das Dimensões da Cultura.
      <br />
      <br />A divulgação dos classificados na dinâmica Destaques da Cultura será realizada por ordem alfabética. Apenas você pode
      visualizar sua pontuação.
    </p>
  );
}

export default function DestaquesCultura({ showHead, options }: DestaqueCulturaProps) {
  const [list, setList] = useState<unknown[]>();
  const [page, setPage] = useState(0);
  const [activePag, setActivePag] = useState(0);
  const [loadingList, setLoadingList] = useState(true);
  const [activeTab, setActiveTab] = useState(0);
  const [showDetail, setShowDetail] = useState<any>('');
  const [selectedValue, setSelectedValue] = useState('');
  const [isMounted, setIsMounted] = useState(false);

  const behaviorsItem = [
    {
      id: 'colaboracao',
      icon: <Selo size={'100%'} cycle={options?.label} selo="Colaboracao" />,
    },
    {
      id: 'foco',
      icon: <Selo size={'100%'} cycle={options?.label} selo="Foco" />,
    },
    {
      id: 'inovacao',
      icon: <Selo size={'100%'} cycle={options?.label} selo="Inovacao" />,
    },
    {
      id: 'resolutividade',
      icon: <Selo size={'100%'} cycle={options?.label} selo="Resolutividade" />,
    },
    {
      id: 'lideranca',
      icon: <Selo size={'100%'} cycle={options?.label} selo="Lideranca" />,
    },
  ];

  const [mask] = useState('');

  const searchRef = useRef<any>();

  function handleDetail(item: any) {
    setShowDetail(item);
  }

  const handleChange = (event: any) => {
    setSelectedValue(event.target.value ? event.target.value : '');
  };

  async function loadData(e?: any, itemPage?: number, clear?: boolean) {
    if (!options?.value) return;

    if (e) {
      e.preventDefault();
    }

    if (clear) {
      setSelectedValue('');
    }

    try {
      const rangeItem = itemPage ? itemPage * 20 : 0;

      setActivePag(itemPage ? itemPage : 0);
      setLoadingList(true);
      setList([]);

      const data = await getResultadosCulturaSecond(
        searchRef.current.value,
        selectedValue ? selectedValue : undefined,
        rangeItem,
        options?.value,
      );

      setPage(data.range.pages);
      setList(data.result);
      setLoadingList(false);
      setIsMounted(true);
    } catch (e) {}
  }

  useEffect(() => {
    if (searchRef.current) {
      searchRef.current.value = '';
    }

    if (options && isMounted) {
      loadData();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, options, selectedValue]);

  useEffect(() => {
    showHead(!!showDetail);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showDetail]);

  const getAriaLabel = (pageIndex: number, selected: boolean) => {
    return selected ? `Página ${pageIndex + 1} selecionada` : `Ir para a página ${pageIndex + 1}`;
  };

  useEffect(() => {
    const pageLinks = document.querySelectorAll('.page-link');
    pageLinks.forEach((link, index) => {
      link.setAttribute('aria-label', getAriaLabel(index, link.classList.contains('active')));
    });
  });

  if (!!showDetail)
    return (
      <DestaquesCulturaDetail
        onClose={() => setShowDetail('')}
        behavior={showDetail.behavior}
        id={showDetail.matricula}
        grupo={showDetail.grupo}
        funcis={showDetail.membros}
        active={options}
      />
    );

  return (
    <>
      <div className="overflow-hidden">
        {/* <div className=" mb-3 lg:mb-10">
          <div className="flex flex-row items-center space-x-3 lg:space-x-1">
            <h1 className="text-lg lg:text-2xl rounded-full flex items-center space-x-1 lg:space-x-3">
              <span>Dimensãoes do comportamento</span>{' '}
              <Tippy arrow={true} className="bg-black" allowHTML={true} content={typeText()}>
                <div>
                  <AiOutlineInfoCircle />
                </div>
              </Tippy>
              <span>|</span> <span className="text-yellow">{options?.label}</span>
            </h1>
          </div>
        </div> */}

        <div className="mb-5 lg:flex items-center justify-end space-x-5">
          {/* <div className="w-full mb-3 lg:mb-0 lg:w-[264px]">
            <CustomSelect
              placeholder="Clique para selecionar o ciclo"
              options={options}
              value={options[activeTab]}
              onChange={(e: any) => setActiveTab(e.value)}
            />
          </div> */}

          <div className="flex flex-row items-center space-x-4">
            <form onSubmit={e => loadData(e, 0, false)} className="pl-1 -ml-1 flex-1 flex space-x-5">
              <label htmlFor="search-cultura-input" className="sr-only">
                Pesquise com nome, matrícula, prefixo ou grupo
              </label>
              <InputMask
                id="search-cultura-input"
                placeholder="Pesquise com nome, matrícula, prefixo ou grupo"
                alwaysShowMask={false}
                mask={mask}
                ref={(ref: any) => {
                  searchRef.current = ref;
                }}
                inputMode="search"
                style={{ fontSize: 16 }}
                className="min-w-full lg:min-w-[416px] bg-maastricht-blue text-sm text-white font-thin flex-1 rounded-md py-2 px-4"
                aria-label="Campo de pesquisa"
              />
            </form>

            <button
              type="button"
              onClick={() => loadData(null, 0, false)}
              className="p-1 hover:ring-2 rounded-full"
              aria-label="Buscar"
            >
              <TbSearch size={28} aria-hidden="true" />
            </button>
          </div>
        </div>

        <div className="mb-5 space-y-2">
          <p className="mb-4" id="filter-label" tabIndex={0}>
            Filtre por dimensão de comportamento
          </p>
          <div className="flex space-x-2 overflow-auto" role="group" aria-labelledby="filter-label">
            <button
              className={`${
                !selectedValue ? 'bg-electric-blue text-prussian-blue-3' : 'border-2'
              } border-grey-light  rounded-3xl py-1 px-3`}
              onClick={() => setSelectedValue('')}
              aria-pressed={!selectedValue}
            >
              TODOS
            </button>
            <button
              className={`border-2 rounded-[50px] mr-4 uppercase px-4 py-3 font-bold leading-3 ${
                selectedValue === 'colaboracao'
                  ? 'bg-electric-blue text-maastricht-blue border-transparent'
                  : 'bg-transparent text-white border-white'
              }`}
              onClick={() => setSelectedValue('colaboracao')}
              aria-pressed={selectedValue === 'colaboracao'}
            >
              COLABORAÇÃO
            </button>
            <button
              className={`border-2 rounded-[50px] mr-4 uppercase px-4 py-3 font-bold leading-3 ${
                selectedValue === 'inovacao'
                  ? 'bg-electric-blue text-maastricht-blue border-transparent'
                  : 'bg-transparent text-white border-white'
              }`}
              onClick={() => setSelectedValue('inovacao')}
              aria-pressed={selectedValue === 'inovacao'}
            >
              INOVAÇÃO
            </button>
            <button
              className={`border-2 rounded-[50px] mr-4 uppercase px-4 py-3 font-bold leading-3 ${
                selectedValue === 'foco'
                  ? 'bg-electric-blue text-maastricht-blue border-transparent'
                  : 'bg-transparent text-white border-white'
              }`}
              onClick={() => setSelectedValue('foco')}
              aria-pressed={selectedValue === 'foco'}
            >
              FOCO NO CLIENTE
            </button>
            <button
              className={`border-2 rounded-[50px] mr-4 uppercase px-4 py-3 font-bold leading-3 ${
                selectedValue === 'resolutividade'
                  ? 'bg-electric-blue text-maastricht-blue border-transparent'
                  : 'bg-transparent text-white border-white'
              }`}
              onClick={() => setSelectedValue('resolutividade')}
              aria-pressed={selectedValue === 'resolutividade'}
            >
              PROTAGONISMO
            </button>
            {options?.date_start >= 1690772400000 && (
              <button
                className={`border-2 rounded-[50px] mr-4 uppercase px-4 py-3 font-bold leading-3 ${
                  selectedValue === 'lideranca'
                    ? 'bg-electric-blue text-maastricht-blue border-transparent'
                    : 'bg-transparent text-white border-white'
                }`}
                onClick={() => setSelectedValue('lideranca')}
                aria-pressed={selectedValue === 'lideranca'}
              >
                {options?.date_start > getNamedDates().ciclo_2S2025 ? 'Liderança Integradora' : 'Liderança Engajadora'}
              </button>
            )}
          </div>
        </div>

        <div className="space-y-5 mb-5">
          <div className="w-full">
            {behaviorsItem
              .filter(item => item.id === selectedValue)
              .map(item => (
                <Box key={item.id}>
                  <div className="space-y-5">
                    <div className="flex flex-row items-start space-x-5 rounded-xl">
                      <div className="w-[100px]" aria-hidden="true">
                        {item.icon}
                      </div>
                      <div className="flex-1">
                        <p className="mb-3 text-electric-blue" tabIndex={0}>
                          {GetBehaviorDescription(item.id)}
                        </p>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: GetBehaviorTextDestaque(item.id),
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>
                </Box>
              ))}
          </div>
        </div>

        {!release ? (
          <Box>
            <div className="space-y-5 lg:p-3">
              <div className="text-center">
                <h3 className="text-xl">Em breve</h3>
              </div>
            </div>
          </Box>
        ) : null}
        {release ? (
          <div className="space-y-5 pt-5">
            {loadingList && (
              <div className="space-y-2">
                <ArticlePlaceholder />
                <ArticlePlaceholder />
              </div>
            )}

            <div className={`${loadingList && 'hidden'} space-y-2`}>
              <div className="flex flex-col space-y-5">
                {/* <div className="space-y-5">
                      <div className="flex flex-row items-center bg-maastricht-blue-3 p-5 space-x-5 rounded-xl">
                        <div className="w-[114px]">
                          {behaviors[activeTab].icon}
                        </div>
                        <div className="flex-1">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: GetBehaviorText(behaviors[activeTab].id),
                            }}
                          ></div>
                        </div>
                      </div> */}

                <Box>
                  {!loadingList && list?.length === 0 && (
                    <div className="text-center">
                      <h3 className="text-xl" tabIndex={0}>
                        Nenhum resultado encontrado
                      </h3>
                    </div>
                  )}

                  <div className="space-y-2">
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4" role="list">
                      {list?.map((item: any, index) => (
                        <button
                          className="bg-maastricht-blue rounded-xl text-white space-y-2 hover:ring-2 h-fit text-left w-full"
                          key={item?._id + '-' + item.behavior + index}
                          onClick={() => handleDetail(item)}
                          onKeyDown={e => {
                            if (e.key === 'Enter' || e.key === ' ') {
                              e.preventDefault();
                              handleDetail(item);
                            }
                          }}
                          aria-label={`Ver detalhes de ${item.nome}, ${item.diretoria} - ${item.funcao}, matrícula ${item.matricula}, grupo: ${item.grupo}`}
                          role="listitem"
                        >
                          <div className="px-4 relative">
                            <div className="flex flex-col items-center justify-around md:h-40 space-y-1 text-center">
                              <div className="w-28 h-28 overflow-hidden rounded-full bg-purple text-3xl font-bold flex flex-row items-center justify-center">
                                {!!item.avatar_type &&
                                  (item.image ? (
                                    <img src={item.image} alt={`Avatar de ${item.nome}`} className="w-full h-full" />
                                  ) : (
                                    <span aria-label={`Inicial ${item.nome[0]}`}>{item.nome[0]}</span>
                                  ))}
                                {!item.avatar_type &&
                                  (!!item.avatar ? (
                                    <Avatar className="w-full h-full" {...item.avatar} />
                                  ) : (
                                    <span aria-label={`Inicial ${item.nome[0]}`}>{item.nome[0]}</span>
                                  ))}
                              </div>

                              {/* <div className="w-20 absolute -top-3 -right-3">
                                {behaviors[item.behavior].icon}
                              </div> */}
                            </div>
                          </div>

                          <div className="bg-prussian-blue-3 w-full  text-center pb-7 pt-5 rounded-b-xl h-[55%]">
                            <div className="font-bold">
                              {item.nome_guerra} - {<span className="font-thin text-electric-blue">{item.matricula}</span>}
                            </div>{' '}
                            <span className="font-thin">{item.nome} </span>
                            <div className="mt-0">
                              <span className="text-electric-blue font-thin">{item.diretoria} </span>
                              <span className="font-thin">- {item.funcao}</span>
                            </div>
                            <div className="text-electric-blue mb-3">
                              <span>Grupo: {item.grupo}</span>
                            </div>
                            <div className="mt-4">
                              <BsPlusLg className="mr-2 inline-block" size={17} color="#C2D2FF" aria-hidden="true" />
                              <span className="uppercase">Ver mais</span>
                            </div>
                          </div>
                        </button>
                      ))}
                    </div>
                  </div>
                </Box>

                <nav className={`flex justify-center mt-5 ${page < 2 && 'hidden'}`} aria-label="Navegação de páginas">
                  <ReactPaginate
                    pageLinkClassName={'page-link'}
                    activeClassName={'item active '}
                    breakClassName={'item break-me '}
                    breakLabel={'...'}
                    containerClassName={'pagination'}
                    disabledClassName={'disabled-page'}
                    nextClassName={'item next '}
                    pageClassName={'item pagination-page '}
                    previousClassName={'item previous'}
                    initialPage={0}
                    forcePage={activePag}
                    nextLabel={
                      <>
                        <IoIosArrowForward style={{ fontSize: 18, width: 150 }} aria-hidden="true" />
                        <span className="sr-only">Próxima página</span>
                      </>
                    }
                    onPageChange={data => loadData(null, data.selected)}
                    pageRangeDisplayed={3}
                    pageCount={page}
                    previousLabel={
                      <>
                        <IoIosArrowBack style={{ fontSize: 18, width: 150 }} aria-hidden="true" />
                        <span className="sr-only">Página anterior</span>
                      </>
                    }
                    ariaLabelBuilder={pageIndex => `Ir para a página ${pageIndex}`}
                  />
                </nav>
                {/* </div> */}
              </div>
            </div>
          </div>
        ) : null}
      </div>
      <Outlet />
    </>
  );
}
